import React, {useEffect, useState} from "react";
import FixedTabs from "../../components/fixed-tabs";
import {CoursesData} from "../types";
import {getUserCourses} from "../../service";
import Pagination from "../../components/pagination";
import usePagination from "../../routers/usePagination";
import CourseItem from "./course-item";
import useUserInfo from "../../routers/useUserInfo";
import {dateFormat} from "../../units";


let tabs = ['我的课程', '过期课程']

function MineCourse() {
    const useData = useUserInfo()
    const [active, setActive] = useState(0)
    const [pageNum, setPage] = useState(1)
    const [lists, setLists] = useState<Array<CoursesData>>([])
    const { pageRef,noMore,reset } = usePagination();


    useEffect(() => {
        if (useData) {
            getUserCourses({
                userId: useData.id,
                pageNum,
                status: 1 - active
            }).then(res => {
                const lists = res.data.list
                if((lists as Array<CoursesData>).length > 0){
                    setLists(list => list.concat(lists))
                }else{
                    noMore()
                }
            })
        }

    }, [pageNum, active])

    const TabChange = (index:number) => {
        setActive(index)
        setLists([])
        setPage(1)
        reset()
    }

    return <div className='mine-course'>
        <FixedTabs tabs={tabs} onChange={TabChange}/>

        <div className="online">
            <CourseItem lists={lists} render={(props:CoursesData) => {
                return <>
                    <p>课程将于 <span>{ dateFormat(props.endTime) }</span> 过期</p>
                    <div className="bt">继续学习</div>
                </>
            }}/>
        </div>

        <Pagination ref={pageRef} length={lists.length}  onChange={ (n) => setPage(n) }/>

    </div>
}

export default MineCourse;
